// Contentful
import safeJsonStringify from 'safe-json-stringify';
import contentfulClient from '../../client/contentful';

// Components
import OgImage from '../../components/OgImage/OgImage';

// Data Utils
import getCategoryHeaderData from '../../utils/data/getCategoryHeaderData';

const ConversionCommunity = (props) => {
  const data = props.data.fields;
  const categoryHeaderData = getCategoryHeaderData(data);

  return (
    <>
      {categoryHeaderData && (
        <OgImage
          {...categoryHeaderData}
          modifier="OgImage--header OgImage--community"
          pattern="Pattern--tolopeaPurple"
        />
      )}
    </>
  );
};

export async function getStaticProps() {
  let data = {};

  const client = contentfulClient;

  await client.getEntry('1h9gF7G2b1tLMGpC8rIUmd', { include: 10 }).then((entry) => {
    data = JSON.parse(safeJsonStringify(entry));
  });
  return {
    props: { data }, // will be passed to the page component as props
  };
}

export default ConversionCommunity;
